import { createPermission } from '@backstage/plugin-permission-common';

export const isPDPTeamMemberPermission = createPermission({
  name: 'isPDPTeamMember.read',
  attributes: {
    action: 'read',
  },
});
